import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const SearchAdvanced = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="SearchAdvanced" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M10 3C14.4183 3 18 6.58172 18 11C18 12.8486 17.3703 14.5487 16.3174 15.9033L20.707 20.293L20.7754 20.3691C21.0957 20.7619 21.0731 21.3409 20.707 21.707C20.3409 22.0731 19.7619 22.0957 19.3691 21.7754L19.293 21.707L14.9033 17.3174C13.5487 18.3703 11.8486 19 10 19C5.58172 19 2 15.4183 2 11C2 6.58172 5.58172 3 10 3ZM10 5C6.68629 5 4 7.68629 4 11C4 14.3137 6.68629 17 10 17C13.3137 17 16 14.3137 16 11C16 7.68629 13.3137 5 10 5Z" fill="#000" /><path d="M20 0C20.5523 0 21 0.447715 21 1V3H23C23.5523 3 24 3.44772 24 4C24 4.55228 23.5523 5 23 5H21V7C21 7.55228 20.5523 8 20 8C19.4477 8 19 7.55228 19 7V5H17C16.4477 5 16 4.55228 16 4C16 3.44772 16.4477 3 17 3H19V1C19 0.447715 19.4477 0 20 0Z" fill="#000" />
  </StyledIcon>
));

SearchAdvanced.displayName = 'SearchAdvanced';

export { SearchAdvanced };
